
import { createAsyncThunk } from "@reduxjs/toolkit";
import { post, get, put, del } from "../../helpers/api_helper";
import slice from "./slice";
import * as URL from "../../helpers/url_helper";
import { toast } from "react-toastify";



export const getRequests = createAsyncThunk(
  "getRequests",
  async ({ data, callback }, Thunk) => {
    try {
      let response = await post(URL.REQUESTS_LIST, data);
             console.log("thi sisss",response);

      callback && callback(null, response);
      return response;
    } catch (error) {
      callback && callback(error?.data?.message || error.message || error);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const deleteRequest = createAsyncThunk(
  "deleteRequest",
  async ({ data, callback }, thunkAPI) => {
    try {
      const response = await del(URL.DELETE_REQUEST + data);
      callback && callback(null, response);
      return response;
    } catch (error) {
      toast.error(error?.message || "Something went wrong!");
      callback && callback(error.message, null);
      return thunkAPI.rejectWithValue(error);
    }
  }
);


export const updateRequest = createAsyncThunk(
    "updateRequest",
    async ({ data, callback }, Thunk) => {
      try {
        // let payload = JSON.parse(JSON.stringify(data));
        // delete payload._id;
        let response = await put(URL.UPDATE_REQUEST + data?._id, data);
        callback && callback(null, response);
        return response
      } catch (error) {
        callback && callback(error?.data?.message || error.message || error);
        return Thunk.rejectWithValue(error);
      }
    }
  );